import "./ProjectLink.scss";

import { Component, h, render } from "preact";

import { LIMITATION_TYPE_ENUM } from "@/api/constants";
import { LogoIcon } from "../Icon/icons/fill/LogoIcon";
import { useLimitation } from "@/hooks/useLimitation";

export function ProjectLink() {
  const isAllowedBrandFree = useLimitation(LIMITATION_TYPE_ENUM.brandFree);

  return isAllowedBrandFree ? null : (
    <div className="CCProjectLink t-text">
      <a href="https://cloudcomments.ru" target="_blank">
        <LogoIcon />
        <span>CloudComments</span>
      </a>
    </div>
  );
}
